{
  // Keep DOM order (and tab order) matching the visual layout at every breakpoint:
  // mobile stacks image-first on every row; desktop honors the server-set alternation.
  // We move nodes rather than use flex-reverse/css order so tabindex stays true.
  const arrange = () => {
    const mobile = window.innerWidth <= 992
    document.querySelectorAll('.staggered-content-featured-image .wrapper > .row').forEach(row => {
      const image = row.querySelector('.col:has(.staggered-content-featured-image--img)')
      const content = row.querySelector('.col:has(.staggered-content-featured-image--text-col)')
      if (!image || !content) return
      const first = (mobile || row.dataset.imageLeft === 'true') ? image : content
      if (row.firstElementChild !== first) row.insertBefore(first, row.firstElementChild)
    })
  }
  arrange()
  window.addEventListener('resize', arrange)
}
